import {
  isUsingKanji,
  isUsingSound,
  notReviewingWrongAnswers,
  notUsingKanji,
  notUsingSound,
} from "./../../store/actions/game.actions";
import {
  getChapterDetails,
  getIsReviewingWrongAnswers,
  getIsUsingKanji,
  getIsUsingSound,
  getQuestions,
  getStudyMethod,
} from "./../../store/selectors/game.selectors";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { Chapter, Question, Vocab } from "src/app/models/game";
import {
  getGameData,
  isReviewingWrongAnswers,
} from "src/app/store/actions/game.actions";
import { GameState } from "src/app/store/reducers/game.reducer";
import { getRandomQuestions } from "src/app/store/selectors/game.selectors";
import { take } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
  selector: "app-multiple-choice",
  templateUrl: "./multiple-choice.component.html",
  styleUrls: ["./multiple-choice.component.scss"],
})
export class MultipleChoiceComponent implements OnInit {
  useKanji$: Observable<Boolean>;
  useSound$: Observable<Boolean>;
  chapter$: Observable<Chapter>;
  questions$: Observable<Question[]>;
  studyMethod$: Observable<string>;
  currentQuestion = 0;
  amountCorrect = 0;
  questionsWrongList = [];
  questionsWrongList$: Observable<Question[]>;
  isReviewingWrongAnswers$: Observable<boolean>;
  isReviewingWrongAnswers: boolean;
  chapterDetail$: Observable<Chapter>;

  constructor(private store: Store<GameState>, private router: Router) {
    this.chapterDetail$ = this.store.select(getChapterDetails);
    this.questions$ = this.store.select(getQuestions);
    this.useKanji$ = this.store.select(getIsUsingKanji);
    this.useSound$ = this.store.select(getIsUsingSound);
    this.studyMethod$ = this.store.select(getStudyMethod);
    this.isReviewingWrongAnswers$ = this.store.select(
      getIsReviewingWrongAnswers
    );
    this.isReviewingWrongAnswers$.subscribe(
      (bool) => (this.isReviewingWrongAnswers = bool)
    );
  }
  ngOnInit() {
    this.questions$.pipe(take(1)).subscribe((questions) => {
      if (questions.length === 0) {
        this.routeToHome();
      }
    });
    this.store.dispatch(getGameData());
  }

  addToReviewList(question) {
    this.questionsWrongList.push(question);
  }

  toggleKanji() {
    this.useKanji$.pipe(take(1)).subscribe((bool) => {
      if (bool) {
        this.store.dispatch(notUsingKanji());
      } else {
        this.store.dispatch(isUsingKanji());
      }
    });
  }
  toggleSound() {
    this.useSound$.pipe(take(1)).subscribe((bool) => {
      if (bool) {
        this.store.dispatch(notUsingSound());
      } else {
        this.store.dispatch(isUsingSound());
      }
    });
  }

  restartGames(event) {
    if (event === "review") {
      this.questionsWrongList$ = of(this.questionsWrongList);
      this.questionsWrongList = [];
      this.store.dispatch(isReviewingWrongAnswers());
    } else {
      this.questionsWrongList = [];
      this.store.dispatch(notReviewingWrongAnswers());
      this.store.dispatch(getGameData());
    }
  }

  routeToHome() {
    this.router.navigate(["../home"]);
  }
}
